export const setStorageWithExpiry = (key, value, expires) => {
  const item = {
    value: value,
    expires: expires
  }
  localStorage.setItem(key, JSON.stringify(item))
}
